import { Spinner } from "flowbite-react";

const Submit = ({ children, isLoading, ...props }) => {
  return (
    <button
      className="text-white bg-fedacash-header text-center w-full py-2 md:py-3 md:px-2 rounded-md text-sm lg:text-base disabled:opacity-50 hover:bg-purple-900"
      disabled={isLoading}
      {...props}
    >
      {!isLoading && children}
      {isLoading && (
        <div className="flex items-center justify-center">
          <Spinner color="info" aria-label="It is loading" />
          <span className="ml-2">Please wait...</span>
        </div>
      )}
    </button>
  );
};

export default Submit;
